
import { useSelector } from "react-redux";


const useUser = () => {
    const allowedUsers = process.env.REACT_APP_ADMINS?.split(",") || [];

    const userData = useSelector((state) => state.user);

    const isAllowed = allowedUsers.includes(userData["email"]);
    console.log("isAllowed", isAllowed, userData["email"], process.env.REACT_APP_ADMINS);
    return isAllowed;

}

export default useUser;
